import { CompanyContact } from "./company-contact";
import { FederalRegistration } from "./federal-registration";
import { SocialNumber } from "./social-number";
import { UntypedFormGroup } from "@angular/forms";
import { JobDescription } from "../Beneficiary/job-description";

interface ICompanyContactHandler {
  handleFormToCompanyContact(companyContactForm: UntypedFormGroup): CompanyContact;
  handleCompanyContactToForm(companyContact: CompanyContact, jobDescriptionList: JobDescription[]): void;
}

export class CompanyContactHandler implements ICompanyContactHandler {
  constructor(private companyContactForm: UntypedFormGroup) {}

  handleFormToCompanyContact(): CompanyContact {
    const companyContact = new CompanyContact();

    companyContact.setCompanyContactKey(this.companyContactForm.get("companyContactKey").value);
    companyContact.setCompanyFiscalNumber(this.companyContactForm.get("companyFiscalNumber").value);
    companyContact.setUnit(this.companyContactForm.get("unit").value);
    companyContact.setName(this.companyContactForm.get("name").value);
    companyContact.setJobDescription(this.companyContactForm.get("jobDescription").value);
    companyContact.setTelephone(
      !!this.companyContactForm.get("telephone").value ? this.companyContactForm.get("telephone").value.replace(/[^\d]+/g, "") : null,
    );
    companyContact.setMobile(!!this.companyContactForm.get("mobile").value ? this.companyContactForm.get("mobile").value.replace(/[^\d]+/g, "") : null);
    companyContact.setEmail(this.companyContactForm.get("email").value);
    companyContact.setArea(this.companyContactForm.get("area").value);
    companyContact.setAdditionalInformation(this.companyContactForm.get("additionalInformation").value);
    companyContact.setHasLegalRepresentativeInfo(this.companyContactForm.get("hasLegalRepresentativeInfo").value);
    companyContact.setFederalRegistration(
      new FederalRegistration(
        !!this.companyContactForm.get("federalRegistration").value ? this.companyContactForm.get("federalRegistration").value.replace(/[./-]/g, "") : "",
      ),
    );
    companyContact.setSocialNumber(
      new SocialNumber(!!this.companyContactForm.get("socialNumber").value ? this.companyContactForm.get("socialNumber").value.replace(/[^\d]+/g, "") : ""),
    );

    return companyContact;
  }

  handleCompanyContactToForm(companyContact: CompanyContact, jobDescriptionList: JobDescription[]): void {
    const jobDescription = companyContact.getJobDescription()
      ? jobDescriptionList.find((jd) => jd.getKey() === companyContact.getJobDescription().getKey())
      : null;

    this.companyContactForm.patchValue({
      companyContactKey: companyContact.getCompanyContactKey(),
      companyFiscalNumber: companyContact.getCompanyFiscalNumber(),
      name: companyContact.getName(),
      unit: companyContact.getUnit(),
      jobDescription,
      telephone: companyContact.getTelephone(),
      mobile: companyContact.getMobile(),
      email: companyContact.getEmail(),
      area: companyContact.getArea(),
      additionalInformation: companyContact.getAdditionalInformation(),
      hasLegalRepresentativeInfo: companyContact.getHasLegalRepresentativeInfo(),
      federalRegistration: companyContact.getFederalRegistration(),
      socialNumber: companyContact.getSocialNumber(),
    });
  }
}
